import { Wishlist } from '../../../models'
import {
  EntityFailAction,
  EntityLoadAction,
  EntitySuccessAction
} from '../../../state/utils/entity-loader/entity-loader.action'
import { MB_WISHLIST_FEATURE } from '../state'
import { Action } from '@ngrx/store'

export const LOAD_DEFAULT_WISHLIST = '[Wishlist] Load Default Wishlist'
export const LOAD_DEFAULT_WISHLIST_SUCCESS = '[Wishlist] Load Default Wishlist Success'
export const LOAD_DEFAULT_WISHLIST_FAIL = '[Wishlist] Load Default Wishlist Fail'

export const ADD_ENTRY_TO_WISHLIST = '[Wishlist] Add Entry To Wishlist'
export const ADD_ENTRY_TO_WISHLIST_SUCCESS = '[Wishlist] Add Entry To Wishlist Success'
export const ADD_ENTRY_TO_WISHLIST_FAIL = '[Wishlist] Add Entry To Wishlist Fail'

export const REMOVE_ENTRY_FROM_WISHLIST = '[Wishlist] Remove Entry From Wishlist'
export const REMOVE_ENTRY_FROM_WISHLIST_SUCCESS = '[Wishlist] Remove Entry From Wishlist Success'
export const REMOVE_ENTRY_FROM_WISHLIST_FAIL = '[Wishlist] Remove Entry From Wishlist Fail'

export class LoadDefaultWishlist extends EntityLoadAction {
  readonly type = LOAD_DEFAULT_WISHLIST
  constructor (public payload: { userId: string }) {
    super(MB_WISHLIST_FEATURE, payload.userId)
  }
}

export class LoadDefaultWishlistSuccess extends EntitySuccessAction {
  readonly type = LOAD_DEFAULT_WISHLIST_SUCCESS
  constructor (public payload: { wishlist: Wishlist; userId: string }) {
    super(MB_WISHLIST_FEATURE, payload?.userId, payload)
  }
}

export class LoadDefaultWishlistFail extends EntityFailAction {
  readonly type = LOAD_DEFAULT_WISHLIST_FAIL
  constructor (public payload: { error: any; userId: string }) {
    super(MB_WISHLIST_FEATURE, payload?.userId, payload)
  }
}

export class AddEntryToWishlist implements Action {
  readonly type = ADD_ENTRY_TO_WISHLIST

  constructor (public payload: {productCode: string; userId: string}) { }
}

export class AddEntryToWishlistSuccess implements Action {
  readonly type = ADD_ENTRY_TO_WISHLIST_SUCCESS

  constructor (public payload: { wishlist: Wishlist; productCode: string; userId: string }) { }
}

export class AddEntryToWishlistFail implements Action {
  readonly type = ADD_ENTRY_TO_WISHLIST_FAIL

  constructor (public payload: any) { }
}

export class RemoveEntryFromWishlist implements Action {
  readonly type = REMOVE_ENTRY_FROM_WISHLIST

  constructor (public payload: {productCode: string; userId: string}) { }
}

export class RemoveEntryFromWishlistSuccess implements Action {
  readonly type = REMOVE_ENTRY_FROM_WISHLIST_SUCCESS

  constructor (public payload: { wishlist: Wishlist; productCode: string; userId: string }) { }
}

export class RemoveEntryFromWishlistFail implements Action {
  readonly type = REMOVE_ENTRY_FROM_WISHLIST_FAIL

  constructor (public payload: any) { }
}

export type WishlistActions = | LoadDefaultWishlist | LoadDefaultWishlistSuccess
                              | AddEntryToWishlist | AddEntryToWishlistSuccess | AddEntryToWishlistFail
                              | RemoveEntryFromWishlist | RemoveEntryFromWishlistSuccess | RemoveEntryFromWishlistFail
